import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {ProfileResponse} from "../types/profile";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import OneSignal from "react-onesignal";

export const fetchProfileData = createAsyncThunk<ProfileResponse>(
    'profile/fetchProfileDate',
    async (_, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const {token} = JSON.parse(authToken);

            const response = await axios.get<ProfileResponse>('/api/profile/info', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            // Дополнительная обработка ошибок сети
            if (axios.isAxiosError(error)) {
                console.error('Network error:', error.message);
            } else {

            }

            // Вернуть rejectWithValue с информацией об ошибке
            return thunkAPI.rejectWithValue('error');
        }
    }
);
